export default [
  {
    path: "/ecommerce/setup",
    name: "/ecommerce-setup",
    component: () => import("@/views/ecommerce/setup.vue"),
    meta: {
      pageTitle: 'Set Up / Users',
      breadcrumb: [
        {
            text: 'Ecommerce Setup / Users',
            active: true,
        },
    ],
      
    },
  },
    {
      path: "/ecommerce/user",
      name: "/ecommerce-user",
      component: () => import("@/views/ecommerce/user.vue"),
      meta: {
        pageTitle: 'User List',
        breadcrumb: [
          {
              text: 'User List',
              active: true,
          },
      ],
        
      },
    },
    {
      path: "/ecommerce/order",
      name: "/ecommerce-order",
      component: () => import("@/views/ecommerce/order.vue"),
      meta: {
        pageTitle: 'Order List',
        breadcrumb: [
          {
              text: 'Order List',
              active: true,
          },
      ],
        
      },
    }

  ];